<!-- あなたへのおすすめ商品 表示アイテム -->
<template>
  <div class="recommend-machine-component">
    <div
      class="recommend-machine-item-wrapper"
      @click="jumpToLink()"
      @keydown="jumpToLink()"
    >
      <div class="recommend-machine-machine-image-wrapper">
        <img
          v-if="machineImageData"
          :src="machineImageData"
          alt="machineImage"
        />
        <div v-else class="loading-icon"></div>
      </div>
      <div class="recommend-machine-text-wrapper">
        <div class="recommend-machine-machine-name">
          {{ recommendMachine.machineName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetchAPI from "@/utils/fetch";
import consoleController from "@/utils/logUtil";
import store from "@/utils/store";
import constant from "@/const";

export default {
  props: {
    /**
     * 以下をキーに持つオブジェクト
     * machineName: おすすめ商品名
     * machineImageId: おすすめ商品の画像を一意に特定するId
     * machineUrl: おすすめ商品押下時のリンク先
     */
    recommendMachine: {
      type: Object,
      required: true,
    },
    skinTypeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      machineImageData: null,
    };
  },
  computed: {},
  mounted() {
    this.getMasterImage(this.recommendMachine.machineImageId);
  },
  methods: {
    async getMasterImage(imageId) {
      const { fetch } = fetchAPI;
      const path = "/web/master/image";
      const queryParams = {
        imageId,
      };
      const lang = store.getUrlLang();
      if (lang !== "") {
        queryParams.lang = lang;
      }
      try {
        const res = await fetch.fetchAPI("GET", path, queryParams);
        if (res !== undefined && res.status === 200) {
          const responseData = await res.json();
          this.machineImageData = `data:image/jpeg;base64, ${responseData.imageBase64}`;
        } else if (res !== undefined && res.status !== 200) {
          // 画像の取得失敗ではエラーダイアログを表示しない
          const errorInfo = await res.json();
          consoleController(
            "error",
            `failed to get master image. errorInfo: ${JSON.stringify(
              errorInfo,
              null,
              4
            )}`
          );
        } else {
          consoleController("error", `failed to get master image.`);
        }
      } catch (e) {
        consoleController("error", `${path}?imageId=${imageId} is failed.`);
      }
    },
    jumpToLink() {
      const paramCountry =
        store.currentCountry.value !== constant.DEFAULT_COUNTRY
          ? `&country=${store.currentCountry.value}`
          : "";
      // 別タブでおすすめ商品のURLを開く
      window.open(
        `${
          this.recommendMachine.machineUrl
        }?skintype=${this.skinTypeId.toLowerCase()}${paramCountry}`,
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.recommend-machine-component {
  padding-top: 18px;
}

.recommend-machine-item-wrapper {
  height: 147px;
  width: 147px;
  position: relative;

  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(27px);
  -webkit-backdrop-filter: blur(27px);
  border-radius: 18px;
}

.recommend-machine-machine-image-wrapper {
  height: 90px;
  width: 90px;
  position: absolute;
  left: 50%;
  bottom: 44px;
  transform: translate(-50%, 0);
}
.recommend-machine-machine-image-wrapper img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.recommend-machine-text-wrapper {
  position: absolute;
  left: 50%;
  bottom: 2px;
  transform: translate(-50%, 0);
  text-align: center;
  width: 100%;
}
.recommend-machine-machine-name {
  font: normal normal 500 12px/16px Noto Sans JP;
  font-weight: bold;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  white-space: pre-line;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
